module.exports = __webpack_public_path__ + "resources/img/main_banner09_m.670e1785ac595260014cbe152484ccd0.png";